import ActionButton from 'src/components/ActionButton'
import { mq, pxToRem, sizes } from 'src/theme'
import styled, { css } from 'styled-components'

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(32)};
`
export const Submit = styled(ActionButton)`
  margin-top: ${pxToRem(40)};

  @media ${mq(sizes.desktop)} {
    margin-top: ${pxToRem(32)};
  }
`

export const StatusMessage = styled.span<{ $error?: boolean }>`
  ${({ theme }) => theme.textStyles.m375_bodySmall};
  display: inline-block;
  margin-top: ${pxToRem(24)};

  ${({ $error, theme }) =>
    $error &&
    css`
      color: ${theme.colors.error};
    `};

  color: ${({ theme }) => theme.colors.greenForest};
`
